module.exports = __webpack_public_path__ + "img/hvor-er-mine-likes-3.f5d14095.png";